import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../../../config';
import formDataValidator from '../../../helpers/formData';
import importer from '../../../helpers/importer';
import './ResetPassword.scss';
/*  ICONS    */
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
/*  COMPONENTS  */
import Alert from '@mui/material/Alert';
import { GestCard } from '@shared/library';
import { languages } from '@shared/library/dist/static/language';
import axios from 'axios';
import {
    CustomButton,
    CustomInput,
} from '../../_gest';
import { CntxConfig } from '../../WebGest';

const ResetPassword = () => {
    //CONTEXTS USE
    const cntxConfig = React.useContext(CntxConfig)!;

    //#region STATIC DATA
    const params = useParams();
    const navigate = useNavigate();
    const lang = languages(cntxConfig.settings?.lang);
    //#endregion

    //#region STATES
    const [sendAgainTimer, setSendAgainTimer] = React.useState(10);
    const [errorAnimation, setErrorAnimation] = React.useState<boolean | string>(false);
    //FLAGS
    const [submitOK, setSubmitOK] = React.useState(false);
    const [isValid, setIsValid] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    // const [error, setError] = useState<boolean|string>(false);
    //#endregion

    //#region METHODS

    //#region API CALLS
    const changePasswordAPI = (e: any) => {
        e.preventDefault();

        const { otp } = params;
        const formData: any = formDataValidator(e.target, 'object');

        if (formData.new_password === formData.confirm_password && formData.confirm_password.length >= 8) {
            setLoading(true);
            axios.post(`${config.api.internal}/Auth/changePassword`, { password: formData.confirm_password, otp }, { withCredentials: true })
                .then(() => setSubmitOK(true))
                .catch(animateError)
                .finally(() => setLoading(false));
        }
        else {
            animateError();
        }

    };

    const validateOtpAPI = () => {
        const { otp } = params;

        if (otp) {
            axios.post(`${config.api.internal}/Auth/validateOTP`, { otp }, { withCredentials: true })
                .then(() => setIsValid(true))
                .catch(animateError)
                .finally(() => setLoading(false));
        }
    };
    //#endregion

    const animateError = () => {
        setErrorAnimation(true);
        setTimeout(() => setErrorAnimation(false), 100);
    };
    //#endregion

    //#region STATES CHANGE
    React.useEffect(validateOtpAPI, []);

    React.useEffect(() => {
        if (((!isValid && !loading) || submitOK) && sendAgainTimer > 0) {
            setTimeout(() => setSendAgainTimer(sendAgainTimer - 1), 1000);
        }
        else if (sendAgainTimer === 0) {
            navigate('/');
        }
    }, [loading, isValid, submitOK, sendAgainTimer]);
    //#endregion

    return (
        <GestCard type="floating" id="Login" style={{ width: '350px' }}>
            <div className="logo">
                <img className={`mb-3 ${loading ? 'spin' : ''} ${errorAnimation ? 'shake' : ''} `} src={importer.img.require('Logo.svg')} alt="" />
                <h4 className='mb-0'>{lang.reset_password}</h4>
            </div>

            <div className='my-4'>
                {loading ?
                    <></>
                    :
                    isValid ?
                        <>
                            {submitOK ?
                                <>
                                    <Alert icon={false}>

                                        <div className='mt-0 w-100 justify-content-center'>
                                            <GppGoodRoundedIcon fontSize='large' />
                                        </div>

                                        <p className='mt-2 mb-1 text-justify'>
                                            {lang.password_reset_successfully}
                                        </p>


                                    </Alert>

                                    <a className='mt-2' onClick={() => { navigate('/'); }}><strong>{lang.back_to_login} {sendAgainTimer ? `(${sendAgainTimer})` : ''}</strong></a>

                                </>
                                :
                                <form onSubmit={changePasswordAPI}>
                                    <fieldset>
                                        <CustomInput type="password" name="new_password" showStrength={true} variant="cloud" img={importer.ic.require('password.svg')} placeholder={lang.password} class="mb-3"></CustomInput>
                                        <CustomInput type="password" name="confirm_password" variant="cloud" img={importer.ic.require('password.svg')} placeholder={lang.repeat_password} class="mb-2"></CustomInput>
                                        <span className={`text-disabled`} style={{ fontSize: 10 }}>* Min. 8 caratteri</span>
                                    </fieldset>
                                    <div>
                                        <CustomButton variant="primary" type={"submit"} class="w-100 mb-2">{lang.reset}</CustomButton>
                                        <a className='' onClick={() => { navigate('/'); }}><strong>{lang.back_to_login}</strong></a>
                                    </div>
                                </form>
                            }
                        </>
                        :
                        <>
                            <Alert severity='error'>
                                <p className='m-0 mb-1 text-justify'>
                                    {lang.password_reset_request_failed_or_expired}
                                </p>
                            </Alert>

                            <a className='mt-2' onClick={() => { navigate('/'); }}><strong>{lang.back_to_login} {sendAgainTimer ? `(${sendAgainTimer})` : ''}</strong></a>
                        </>
                }
            </div>
        </GestCard>
    );
};
export default React.memo(ResetPassword);